import { render, staticRenderFns } from "./activity_page.vue?vue&type=template&id=01d9a00c&scoped=true"
import script from "./activity_page.vue?vue&type=script&lang=js"
export * from "./activity_page.vue?vue&type=script&lang=js"
import style0 from "./activity_page.vue?vue&type=style&index=0&id=01d9a00c&scoped=true&lang=css"
import style1 from "./activity_page.vue?vue&type=style&index=1&id=01d9a00c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d9a00c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d9a00c')) {
      api.createRecord('01d9a00c', component.options)
    } else {
      api.reload('01d9a00c', component.options)
    }
    module.hot.accept("./activity_page.vue?vue&type=template&id=01d9a00c&scoped=true", function () {
      api.rerender('01d9a00c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group_buy/activity_page.vue"
export default component.exports